import React from "react";
import {
  SimpleForm,
  SelectInput,
  EditProps,
  FormDataConsumer,
  useEditController,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomEditToolbar from "components/CustomEditToolbar";
import CustomEndDateInput from "components/CustomEndDateInput";
import DaysOfWeekInput from "components/DaysOfWeekInput";
import CustomDatePickerInput from "components/CustomDatePickerInput";
import { typeList } from "./conts";
import RouteInput from "./components/RouteInput";
import StudentInput from "./components/StudentInput";
import WaveInput from "./components/WaveInput";
import EditWrapper from "../../components/EditWrapper";
import PermissionLoading from "../../components/PermissionLoading";

const NotTakingEdit = (props: EditProps) => {
  const { id } = props;
  const { record, loading } = useEditController(props);

  const breadcrumb = [
    { link: "/notTakingStudents", title: "Exclude Students" },
    { link: `/notTakingStudents/${id}`, title: id },
  ];

  const transform = async (data: any) => {
    if (data.type === "day") {
      data.period = null;

      data.isMonday = data.isMonday ? true : false;
      data.isTuesday = data.isTuesday ? true : false;
      data.isWednesday = data.isWednesday ? true : false;
      data.isThursday = data.isThursday ? true : false;
      data.isFriday = data.isFriday ? true : false;
      data.isSaturday = data.isSaturday ? true : false;
      data.isSunday = data.isSunday ? true : false;
    }

    if (data.type === "date") {
      data.period = {
        start: data.startDate,
        end: data.endDate,
      };

      delete data.startDate;
      delete data.endDate;

      data.isMonday = false;
      data.isTuesday = false;
      data.isWednesday = false;
      data.isThursday = false;
      data.isFriday = false;
      data.isSaturday = false;
      data.isSunday = false;
    }

    return data;
  };

  const formatRecord = (res: any) => {
    if (res) {
      if (res.period === null) {
        res.type = "day";
      } else {
        res.type = "date";
        res.startDate = res.period?.start;
        res.endDate = res.period?.end;
      }
    }
    return res;
  };

  if (loading) {
    return <PermissionLoading />;
  }

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customNameWithId="Exclude Student"
        transform={transform}
        isHaveSchoolFilter
        {...props}
      >
        <SimpleForm
          record={formatRecord(record)}
          toolbar={<CustomEditToolbar isDeleteWithConfirm />}
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Route Plan</Typography>
            </Grid>
            <Grid item xs={4}>
              <WaveInput isDisable={true} isEdit={true} />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Route </Typography>
            </Grid>
            <Grid item xs={4}>
              <RouteInput isDisable={true} />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>
            <Grid item xs={4}>
              <StudentInput isDisable={true} />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Not Taking Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <SelectInput source="type" choices={typeList} />
            </Grid>
            <Grid item xs={8}></Grid>

            <FormDataConsumer>
              {({ formData, ...rest }) =>
                formData.type === "day" ? (
                  <>
                    <DaysOfWeekInput />
                  </>
                ) : (
                  formData.type === "date" && (
                    <>
                      <Grid item xs={4}>
                        <CustomDatePickerInput
                          name="startDate"
                          label="Start Date"
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <CustomEndDateInput
                          source="endDate"
                          label="End Date"
                          comparison="startDate"
                        />
                      </Grid>
                      <Grid item xs={4}></Grid>
                    </>
                  )
                )
              }
            </FormDataConsumer>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default NotTakingEdit;
